/**
 * Auto-generated file created by svgr-cli source svgr.template.config.js
 * Run yarn svgr to update
 * Do not edit
 */
import * as React from 'react'
import { SVGProps, memo } from 'react'
const SvgUploadZip = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 24}
    height={props.height || 24}
    fill="currentColor"
    viewBox="0 0 60 61"
    color={props.color || '#EE4D2D'}
    {...props}
  >
    <path
      fill="currentColor"
      d="M44.794 25.433h6.187c.284 0 .604.009.96.027a7.912 7.912 0 0 1 2.453.48 5.613 5.613 0 0 1 1.973 1.226 5.533 5.533 0 0 1 1.334 1.974c.337.782.506 1.697.506 2.746 0 1.032-.169 1.947-.506 2.747a5.533 5.533 0 0 1-1.334 1.973 5.612 5.612 0 0 1-1.973 1.227 7.915 7.915 0 0 1-2.453.48c-.356.018-.676.027-.96.027h-1.787v4.16h-4.4V25.433Zm4.667 8.56h1.866a6.4 6.4 0 0 1 .507-.027c.569-.035 1.058-.204 1.467-.506.408-.32.613-.845.613-1.574 0-.729-.213-1.244-.64-1.546-.409-.32-.898-.498-1.467-.534h-.48a7.13 7.13 0 0 0-.64-.026h-1.493v4.213h.267ZM41.596 42.5h-4.8V25.433h4.8V42.5ZM27.947 29.753H21.12v-4.32H33.6v4.107l-6.8 8.64h4.96l2.906 4.32H20.8v-3.654l7.146-9.093Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M39.328 4.5H3.5V57H49V44.5h-4V53H7.5V8.5h26v11H45v3h4v-8.328L39.328 4.5Zm5.344 11-7-7H37.5v7h7.172Z"
      clipRule="evenodd"
    />
  </svg>
)
const Memo = memo(SvgUploadZip)
export default Memo
